import React, { useCallback } from 'react';
import { Button, Grid, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import FormikFormWrapper from 'libs/formik_fields/FormikFormWrapper';

import { LoadingButton } from '@mui/lab';
import appUrls from 'appUrls';
import QuestionField from './QuestionField';
import { FieldArray } from 'formik';

const questionsFormSchema = yup.object().shape({
    questions: yup.mixed().required('Questions is required')
});

const useStyles = makeStyles((theme) => ({
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}));

const QuestionsFormContent = (formik) => {
    const { isSubmitting, values } = formik;

    return (
        <Grid container spacing={3}>
            {/* <pre>{JSON.stringify(values, null, 3)}</pre> */}
            <FieldArray
                name="questions"
                render={(arrayHelpers) => (
                    <>
                        {values.questions.map((question, index) => {
                            // if (question.optionType === 'MANUAL' && question.pollQuestionOptions.length < 0) {
                            //     console.log('Do noting');
                            // } else if (question.optionType === 'STUDENT' && values.students.length < 0) {
                            //     console.log('Do noting');
                            // } else {
                            //     sno += 1;
                            // }
                            return (
                                <>
                                    <Grid item xs={12} key={question._id}>
                                        <QuestionField question={question} index={index} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                </>
                            );
                        })}
                    </>
                )}
            />

            <Grid item xs={12} style={{ paddingTop: 0 }}>
                <LoadingButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disableElevation
                    loading={isSubmitting}
                    loadingPosition="center"
                >
                    Save
                </LoadingButton>
            </Grid>
        </Grid>
    );
};

function YearBookForm({ handleSubmit, initialValues }) {
    return (
        <FormikFormWrapper
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={questionsFormSchema}
            FormContent={QuestionsFormContent}
        />
    );
}

export default YearBookForm;
